import React, { useReducer, useContext, useState } from "react";
import { useWindowDimensions } from "react-native";
import { useTheme } from "@emotion/react";
import { AppTheme } from "../../../../utils/theme";
import { FurnitureContext } from "../../../../utils/furniture";
import { Body, Caption } from "../../styles";
import {
    Cta,
    CtaContainer,
    Main,
    Priorities,
    Priority,
    PriorityLabel,
    PriorityIcon,
    PriorityLevel,
    ProgressMulti as Progress,
} from "./styles";
import {
    InlineRichText,
    HeadlineRichText,
} from "../../../../components/RichText";
import { QuizQuestionComponentProps } from "../../index";
import "./webSlider.css";

enum Action {
    SetPriority = "SET_PRIORITY",
}

const reducer = (state, action) => {
    let nextState = state;

    switch (action.type) {
        case Action.SetPriority: {
            const { position } = action;
            let priorityScoreA = 50 - position,
                priorityScoreB = 50 + position;

            nextState = {
                ...state,
                priorityScoreA,
                priorityScoreB,
            };
        }
    }

    return nextState;
};

const initialState = {
    position: 0,
    priorityScoreA: 50,
    priorityScoreB: 50,
};

type Option = {
    _id: string;
    body: string;
    bodyRich: any;
    priorityIcon: {
        url: string;
    };
};

const QuizQuestionPrioritySelect = ({
    question,
    options,
    index,
    count,
    next,
}: QuizQuestionComponentProps) => {
    const [{ position, priorityScoreA, priorityScoreB }, dispatch] = useReducer(
        reducer,
        initialState,
    );
    const furniture = useContext(FurnitureContext);
    const { width } = useWindowDimensions();
    const windowWidth = Math.floor(width);
    const questionId = question._id;
    const [priorityA, priorityB] = options as any[];
    const optionIds = [priorityA._id, priorityB._id];
    const optionValues = [priorityScoreA, priorityScoreB];
    const [value, setValue] = useState(position);

    const {
        color: { backgroundAccent, enabled, trackColor },
    }: AppTheme = useTheme() as AppTheme;

    const handleValueChange = position => {
        setValue(position);
        dispatch({
            type: Action.SetPriority,
            position,
        });
    };

    /**
     *
     * @param options
     * @returns
     */
    const renderPriority = (priority: Option, score) => {
        const imageUrl =
            priority.priorityIcon?.url &&
            `https:${priority.priorityIcon.url}?w=${windowWidth}`;
        return (
            <Priority key={priority._id}>
                <PriorityLevel type="body1" allowFontScaling={false}>
                    {`${score}%`}
                </PriorityLevel>
                <PriorityIcon source={{ uri: imageUrl }} />
                <PriorityLabel allowFontScaling={false}>
                    {priority.bodyRich ? (
                        <InlineRichText doc={priority.bodyRich} />
                    ) : (
                        priority.bodyRich
                    )}
                </PriorityLabel>
            </Priority>
        );
    };
    return (
        <>
            <Main>
                <Progress type="caption1">{`${
                    index && index + 1
                } of ${count}`}</Progress>
                <Body type="h8">
                    <HeadlineRichText doc={question.bodyRich} />
                </Body>
                {question.captionRich && (
                    <Caption type="caption1">
                        <InlineRichText doc={question.captionRich} />
                    </Caption>
                )}
                <Priorities>
                    {renderPriority(priorityA, priorityScoreA)}
                    {renderPriority(priorityB, priorityScoreB)}
                </Priorities>
                <input
                    className="web-slider"
                    type="range"
                    min="-50"
                    max="50"
                    value={value}
                    onChange={e => handleValueChange(parseInt(e.target.value))}
                />
                <CtaContainer>
                    <Cta
                        title={furniture.strings.nextCta}
                        onPress={() =>
                            next &&
                            next([
                                {
                                    questionId,
                                    optionIds,
                                    optionValues,
                                },
                            ])
                        }
                    />
                </CtaContainer>
            </Main>
        </>
    );
};

export default QuizQuestionPrioritySelect;
